<template>
  <v-container fluid>
    <v-card>
      <v-card-title>通関費用詳細</v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_CCP_NEW>{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout column>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete label="サプライヤー" url="companies/kv" v-model="form.supplierId"/>
            </v-flex>

            <v-flex md3 sm6 xs6>
              <remote-select
                clearable
                label="申告区分名"
                url="/customs-declaration-paper-types/kv"
                v-model="form.typeId"
              />
            </v-flex>

            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="通関料金" v-model="form.price"></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="form.startDate"></date-picker>
            </v-flex>

            <v-flex md3 sm6 xs6>
              <date-picker :min="form.startDate" label="適用終了日" v-model="form.endDate"></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {},
      nameRules: [v => !!v || 'Name is required']
    }
  },
  methods: {
    save() {
      this.$http.post('/customs-clearance-price', this.form).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
